// @flow

import React, { useState } from 'react';
import {
    Box, Heading, Text, TextInput,
} from 'grommet';
import { point12Messages } from 'esm-web-pro/messages/points12Messages';
import { FormNextLink } from 'grommet-icons';
import { FormattedMessage, IntlShape } from 'react-intl';

type Props = {
    cableList: Array,
    cable: Object,
    index: Number,
    inputErrors: Obejct,
    changedDisconCables: Object,
    handleInputChange: (e: SyntheticFocusEvent<any>, point12: Object) => void,
    intl: IntlShape,
};

const Point11ReorderCables = (props: Props) => {
    const {
        cableList, changedDisconCables, cable, index, handleInputChange, inputErrors, intl: { formatMessage },
    } = props;

    let value;

    if (changedDisconCables[cable.id]) {
        value = changedDisconCables[cable.id].sequence;
    } else {
        value = cable.sequence;
    }

    return (
        <Box pad={{ right: '92px' }} flex={{ shrink: 0 }}>
            { index === 0
            && (
                <>
                    <Heading level={6}>
                        {cable.patch ? (
                            <FormattedMessage
                                id="patch-cables"
                                defaultMessage="Patch Cables"
                            />
                        ) : (
                            <FormattedMessage
                                id="disconnected-cables-order-title"
                                defaultMessage="Disconnected cables"
                            />
                        )}
                    </Heading>
                    <Box margin={{ top: 'small' }} />
                </>
            )}
            <Box direction="row">
                <Box
                    direction="row"
                    margin={{ right: 'xsmall' }}
                    fill="horizontal"
                >
                    <Box
                        direction="row"
                        fill="horizontal"
                    >
                        <Box pad={{ top: '3px' }} justify="center">
                            <Text>
                                {cable.patch ? (
                                    <FormattedMessage
                                        id="patch-cable-panel-title"
                                        defaultMessage="Patch Cable"
                                    />
                                ) : (
                                    <FormattedMessage
                                        id="cablelist-item-title"
                                        defaultMessage="Disconnected cables"
                                    />
                                )}
                            </Text>
                        </Box>
                        <Box
                            direction="row"
                            fill="horizontal"
                            justify="end"
                            pad={{ right: '40px' }}
                            align="center"
                        >
                            <Box alignSelf="center" gap="xsmall" direction="row" pad={{ right: 'xsmall' }}>
                                <Text alignSelf="center">
                                    {`${cable.sequence}`}
                                </Text>
                                <FormNextLink />
                            </Box>
                            <Box>
                                <TextInput
                                    style={Object.prototype.hasOwnProperty.call(inputErrors, cable.id)
                                        ? { backgroundColor: 'red', color: 'white' } : {}}
                                    size="small"
                                    name="cable-input"
                                    type="number"
                                    onChange={(e) => handleInputChange(e, cable)}
                                    min={0}
                                    value={value}
                                />
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
            { Object.prototype.hasOwnProperty.call(inputErrors, cable.id)
            && (
                <Box pad={{ left: 'medium', right: 'medium' }}>
                    <Text
                        color="status-error"
                        alignSelf="center"
                        margin={{ top: '10px' }}
                    >
                        {changedDisconCables[cable.id].sequence < 0 ? (
                            <FormattedMessage
                                id="point11-order-negative-input-text-msg"
                                defaultMessage="The sequence number cannot be negative!"
                            />
                        ) : (
                            <FormattedMessage
                                id="point11-order-input-text-msg"
                                defaultMessage="The given sequence number exists!"
                            />
                        )}
                    </Text>
                </Box>
            )
            }
        </Box>
    );
};

export default Point11ReorderCables;
